import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DirectionState } from './types';

const initialState: DirectionState = {
  value: 'ltr',
};

export const directionSlice = createSlice({
  name: 'direction',
  initialState,
  reducers: {
    setDirection: (state, action: PayloadAction<'ltr' | 'rtl'>) => {
      state.value = action.payload;
    },
  },
});

export const { setDirection } = directionSlice.actions;

export const selectDirection = (state: any) => {
    const slice = state.get ? state.get('direction') : state.direction;
    return slice || initialState;
};

export default directionSlice.reducer;